import { render, staticRenderFns } from "./recharge.vue?vue&type=template&id=8c893d24&scoped=true"
import script from "./recharge.vue?vue&type=script&lang=js"
export * from "./recharge.vue?vue&type=script&lang=js"
import style0 from "./recharge.vue?vue&type=style&index=0&id=8c893d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c893d24",
  null
  
)

export default component.exports